/* ===========================
   MOHAR THEME — theme.js
   All interactive JS for homepage & product page
   =========================== */

document.addEventListener('DOMContentLoaded', function () {

  // === 1. SCROLL-BASED NAV (Homepage) ===
  const nav = document.getElementById('nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.classList.toggle('solid', window.scrollY > 60);
    }, { passive: true });
  }

  // === 2. SCROLL REVEAL ANIMATION ===
  const revealEls = document.querySelectorAll('.rv, .reveal');
  if (revealEls.length > 0) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('on', 'visible');
          observer.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(el => observer.observe(el));
  }

  // === 3. MODE PILL ROTATOR (Homepage Hero) ===
  const pillIds = ['mp0', 'mp1', 'mp2', 'mp3'];
  let pillIdx = 0;
  const pillEl = document.getElementById('mp0');
  if (pillEl) {
    setInterval(() => {
      const prev = document.getElementById(pillIds[pillIdx]);
      if (prev) prev.classList.remove('mp-active');
      pillIdx = (pillIdx + 1) % pillIds.length;
      const next = document.getElementById(pillIds[pillIdx]);
      if (next) next.classList.add('mp-active');
    }, 2000);
  }

  // === 4. FAQ ACCORDION ===
  window.toggleFaq = function (btn) {
    const item = btn.closest('.faq-item');
    const wasOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item.open').forEach(i => i.classList.remove('open'));
    if (!wasOpen) item.classList.add('open');
  };

  // === 5. USE CASE TABS (Homepage) ===
  window.switchUC = function (btn, id) {
    document.querySelectorAll('.uc-tab').forEach(b => b.classList.remove('active'));
    document.querySelectorAll('.uc-panel').forEach(p => p.classList.remove('active'));
    btn.classList.add('active');
    const panel = document.getElementById('uc-' + id);
    if (panel) panel.classList.add('active');
  };

  // === 6. USE CASE TABS (Product Page) ===
  window.switchTab = function (id) {
    document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
    document.querySelectorAll('.tab-panel').forEach(p => p.classList.remove('active'));

    const activeBtn = document.querySelector(`[onclick="switchTab('${id}')"]`);
    if (activeBtn) activeBtn.classList.add('active');

    const panel = document.getElementById('tab-' + id);
    if (panel) panel.classList.add('active');
  };

  // === 7. STICKY BAR (Homepage) ===
  const heroSection = document.getElementById('hero');
  const stickyBar = document.getElementById('sticky');
  if (heroSection && stickyBar) {
    window.addEventListener('scroll', () => {
      const heroBottom = heroSection.offsetTop + heroSection.offsetHeight;
      stickyBar.classList.toggle('show', window.scrollY > heroBottom - 100);
    }, { passive: true });
  }

  // === 8. STICKY BAR (Product Page) ===
  const productHero = document.getElementById('product-hero');
  const productStickyBar = document.getElementById('sticky-bar');
  if (productHero && productStickyBar) {
    window.addEventListener('scroll', () => {
      const heroBottom = productHero.offsetTop + productHero.offsetHeight;
      productStickyBar.classList.toggle('visible', window.scrollY > heroBottom - 200);
    }, { passive: true });
  }

  // === 9. PRODUCT GALLERY SWITCHER ===
  window.switchThumb = function (thumb, imgSrc) {
    document.querySelectorAll('.thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
    const mainImg = document.getElementById('main-img');
    if (mainImg && imgSrc) {
      mainImg.src = imgSrc;
      mainImg.style.display = 'block';
    }
  };

  // === 10. VARIANT SELECTOR (Product Page) ===
  window.selectVariant = function (card, variantId, price) {
    document.querySelectorAll('.variant-card').forEach(c => c.classList.remove('selected'));
    card.classList.add('selected');

    // Update hidden variant input
    const variantInput = document.getElementById('variant-id');
    if (variantInput && variantId) variantInput.value = variantId;

    // Update price display
    const priceMain = document.querySelector('.price-main');
    if (priceMain && price) priceMain.textContent = price;

    // Update buy button text
    const buyBtn = document.getElementById('buy-now-btn');
    if (buyBtn && price) {
      buyBtn.innerHTML = `
        <svg viewBox="0 0 20 20" fill="currentColor" width="18" height="18"><path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"/></svg>
        Buy Now — ${price}
      `;
    }
  };

  // === 11. ADD TO CART (AJAX) ===
  window.addToCartAjax = function () {
    const variantInput = document.getElementById('variant-id');
    if (!variantInput || !variantInput.value) return;

    const variantId = variantInput.value;
    const btn = document.querySelector('.btn-addcart');
    if (btn) {
      btn.textContent = 'Adding...';
      btn.disabled = true;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(res => res.json())
    .then(() => {
      if (btn) {
        btn.textContent = '✓ Added to Cart';
        btn.style.borderColor = 'var(--forest-m)';
        btn.style.color = 'var(--forest-m)';
        setTimeout(() => {
          btn.textContent = 'Add to Cart';
          btn.style.borderColor = '';
          btn.style.color = '';
          btn.disabled = false;
        }, 2000);
      }
    })
    .catch(() => {
      if (btn) {
        btn.textContent = 'Add to Cart';
        btn.disabled = false;
      }
    });
  };

  // === 12. VIDEO PLAYER (Homepage Story Section) ===
  window.playStoryVideo = function () {
    const iframe = document.getElementById('story-iframe');
    const vpb = document.getElementById('vpb');
    const videoBg = document.querySelector('.video-product-bg');
    if (iframe) {
      iframe.src = 'https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=1&rel=0';
      iframe.style.display = 'block';
    }
    if (vpb) vpb.style.display = 'none';
    if (videoBg) videoBg.style.display = 'none';
  };

  // === 13. SMOOTH SCROLL FOR ANCHOR LINKS ===
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href === '#') return;
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        const offset = 80;
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

});
